<template>
  <div 
    class="  px-10 mt-6">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <section>
          <div class="color-dark-blue fs-16 font-weight-bold">
            Ubah Kategori
          </div>

          <v-card 
            class="mt-4"
            flat
            height="calc(100vh - 200px)"
            style="background: transparent; border: 1px solid #E7E7E7;">
            <v-card-text class="">

              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="Nama Kategori Pegawai" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 label-input mb-2">
                          Nama Kategori Pegawai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. Admin"

                          
                          :item-color="set_color"

                          v-model="form.title"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <div>
                    <div class="fs-15 label-input mb-2">
                      Hak Akses
                    </div>

                    <div
                      style="height: calc(100vh - 400px); overflow-y: auto;" class="px-5">
                      <div v-for="(item, index) in list" :key="index">
                        <v-checkbox hide-details :value="item.id" v-model="form.menu_arr" >
                          <template v-slot:label>
                            <div class="d-flex align-center">
                              <v-icon size="18">{{ item.icon }}</v-icon>
                              <div class="black--text ml-2 fs-14">{{ item.label }}</div>
                            </div>
                          </template>
                        </v-checkbox>
                        <div v-if="Object.keys(item.action).length > 0">
                          <div v-if="item.id === 1" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <!-- <v-checkbox hide-details class="mx-4" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_sub" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Tambah Sub
                                </div>
                              </template>
                            </v-checkbox> -->
                          </div>

                          <div v-if="item.id === 2" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 2 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 2 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 2 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 2 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 2 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 2 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 15" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.detail" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                  Detail
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.ubah_detail" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                  Ubah Detail
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.hapus_detail" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                  Hapus Detail
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          
                          <div v-if="item.id === 7" class="ml-5 fs-12">
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.detail" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Detail
                                  </div>
                                </template>
                              </v-checkbox>
                              <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Tambah
                                  </div>
                                </template>
                              </v-checkbox>
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Ubah
                                  </div>
                                </template>
                              </v-checkbox>
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Hapus
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class="pt-2 font_weight_600 ml-2">
                              Persiapan
                            </div>
                            <!-- <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.persiapan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Data Persiapan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div> -->
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1"  v-on:change="item.action.rab_internal === false ? update_rab_internal(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Rab Internal
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_internal">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_internal ? '' : 'black--text'">
                                    Tambah Rab Internal
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_internal">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_internal ? '' : 'black--text'">
                                    Ubah Rab Internal
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_internal">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_internal ? '' : 'black--text'">
                                    Hapus Rab Internal
                                  </div>
                                </template>
                              </v-checkbox> 
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.detail_rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.rab_internal">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.rab_internal ? '' : 'black--text'">
                                    Detail Rab Internal
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-10">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_detail_rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.detail_rab_internal">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.detail_rab_internal ? '' : 'black--text'">
                                    Tambah Detail Rab Internal
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-10">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_detail_rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.detail_rab_internal">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.detail_rab_internal ? '' : 'black--text'">
                                    Ubah Detail Rab Internal
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-10">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_detail_rab_internal" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.detail_rab_internal">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.detail_rab_internal ? '' : 'black--text'">
                                    Hapus Detail Rab Internal
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.rab_penawaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.rab_internal === false ? update_rab_penawaran(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Rab Penawaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_tools_rab_penawaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_penawaran">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_penawaran ? '' : 'black--text'">
                                    Update Tools Rab Penawaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_rab_penawaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_penawaran">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_penawaran ? '' : 'black--text'">
                                    Update Rab Penawaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>  
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_rab_penawaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_penawaran">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.rab_penawaran ? '' : 'black--text'">
                                    Hapus Rab Penawaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.bobot" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.bobot === false ? update_bobot(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Bobot
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_bobot" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.bobot">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.bobot ? '' : 'black--text'">
                                    Ubah Bobot
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.document" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.document === false ? update_document(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Dokument
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_document" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.document">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 
                              || !item.action.document ? '' : 'black--text'">
                                    Ubah Dokument
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.chacklist_persiapan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Chacklist Persiapan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class="pt-2 font_weight_600 ml-2">
                              Penawaran
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.penawaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.penawaran === false ? update_penawaran(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Data Penawaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_penawaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.penawaran">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.penawaran ? '' : 'black--text'">
                                    Ubah Penawaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class="pt-2 font_weight_600 ml-2">
                              Negosiasi
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.negosiasi" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.negosiasi === false ? update_negosiasi(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Data Negosiasi
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_negosiasi" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.negosiasi">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.negosiasi ? '' : 'black--text'">
                                    Ubah Negosiasi
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class="pt-2 font_weight_600 ml-2">
                              Pelaksanaan
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.pelaksanaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.pelaksanaan === false ? update_pelaksanaan(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Informasi Pelaksanaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_pelaksanaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pelaksanaan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pelaksanaan ? '' : 'black--text'">
                                    Ubah Informasi Pelaksanaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.rencana_kebutuhan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.rencana_kebutuhan === false ? update_rencana_kebutuhan(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Rencana Kebutuhan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_rencana_kebutuhan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.rencana_kebutuhan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.rencana_kebutuhan ? '' : 'black--text'">
                                    Ubah Rencana Kebutuhan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.rencana_belanja" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Rencana Belanja
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.realisasi_kebutuhan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.realisasi_kebutuhan === false ? update_realisasi_kebutuhan(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Realisasi Kebutuhan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_realisasi_kebutuhan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.realisasi_kebutuhan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.realisasi_kebutuhan ? '' : 'black--text'">
                                    Tambahan Realisasi Kebutuhan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_realisasi_kebutuhan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.realisasi_kebutuhan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.realisasi_kebutuhan ? '' : 'black--text'">
                                    Ubah Realisasi Kebutuhan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.realisasi_belanja" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.realisasi_belanja === false ? update_realisasi_belanja(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Realisasi Belanja
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_realisasi_belanja" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.realisasi_belanja">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.realisasi_belanja ? '' : 'black--text'">
                                    Ubah Realisasi Belanja
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.kemajuan_pekerjaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.kemajuan_pekerjaan === false ? update_kemajuan_pekerjaan(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Kemajuan Pekerjaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_kemajuan_pekerjaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.kemajuan_pekerjaan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.kemajuan_pekerjaan ? '' : 'black--text'">
                                    Ubah Kemajuan Pekerjaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.cco" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Laporan CCO
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class="pt-2 font_weight_600 ml-2">
                              Pelaporan dan Evaluasi
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.berita_acara" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.berita_acara === false ? update_berita_acara(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Berita Acara
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_berita_acara" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.berita_acara">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.berita_acara ? '' : 'black--text'">
                                    Tambah Berita Acara
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_berita_acara" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.berita_acara">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.berita_acara ? '' : 'black--text'">
                                    Ubah Berita Acara
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_berita_acara" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.berita_acara">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.berita_acara ? '' : 'black--text'">
                                    Hapus Berita Acara
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.tahap_pembayaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.tahap_pembayaran === false ? update_tahap_pembayaran(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Tahap Pembayaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_tahap_pembayaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.tahap_pembayaran">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.tahap_pembayaran ? '' : 'black--text'">
                                    Tambah Tahap Pembayaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_tahap_pembayaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.tahap_pembayaran">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.tahap_pembayaran ? '' : 'black--text'">
                                    Ubah Tahap Pembayaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_tahap_pembayaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.tahap_pembayaran">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.tahap_pembayaran ? '' : 'black--text'">
                                    Hapus Tahap Pembayaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.ketentuan_pembayaran" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Ketenntuan Pembayaran
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class="pt-2 font_weight_600 ml-2">
                              Pengadaan/Logistik
                            </div>
                            <div class=" d-flex align-center">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1" v-on:change="item.action.pengadaan === false ? update_pengadaan(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                    Data Pengadaan/Logistik
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan ? '' : 'black--text'">
                                    Tambah Data Pengadaan/Logistik
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan ? '' : 'black--text'">
                                    Ubah Data Pengadaan/Logistik
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan ? '' : 'black--text'">
                                    Hapus Data Pengadaan/Logistik
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.item_pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan" v-on:change="item.action.item_pengadaan === false ? update_item_pengadaan(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan ? '' : 'black--text'">
                                    Item Barang / Pekerjaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-10">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_item_pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.item_pengadaan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.item_pengadaan ? '' : 'black--text'">
                                    Ubah Item Barang / Pekerjaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-5">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.pembayaran_pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan" v-on:change="item.action.pembayaran_pengadaan === false ? update_pembayaran_pengadaan(item) : ''">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pengadaan ? '' : 'black--text'">
                                    Pembayaran Pengadaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <div class=" d-flex align-center ml-10">
                              <v-checkbox hide-details class="mx-4" dense v-model="item.action.update_pembayaran_pengadaan" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pembayaran_pengadaan">
                                <template v-slot:label>
                                  <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 || !item.action.pembayaran_pengadaan ? '' : 'black--text'">
                                    Ubah Pembayaran Pengadaan
                                  </div>
                                </template>
                              </v-checkbox>
                            </div>
                            <!-- <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox> -->
                          </div>

                          <div v-if="item.id === 11" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.reset_password" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Reset Password
                                </div>
                              </template>
                            </v-checkbox>
                            <!-- <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox> -->
                          </div>

                          <div v-if="item.id === 12" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 12 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 12 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 12 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 12 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 12 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 12 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 14" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <!-- <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah & Ubah Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_project" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah Project
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_project" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus Project
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox> -->
                          </div>


                          <!-- <div v-if="item.id === 9" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div> -->
                        </div>
                      </div>

                    </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>


          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-3"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/category-user"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row> -->
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        role: [
          {
            id: 1,
            name: 'Admin'
          },
          {
            id: 2,
            name: 'Pegawai' 
          }
        ],
        list:[
        {
            id: 1,
            label: "Client",
            icon: "mdi-file-cog",
            link: "/client",
            color: "primary",
            action: {
              add: true,
              update: true,
              delete: true,
              export: true,
              add_sub: true
            }
          },
          {
            id: 2,
            label: "Master harga satuan",
            icon: "mdi-bookmark-box",
            link: "/ahsp",
            color: "accent",
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 15,
            label: "Master AHSP",
            icon: "mdi-text-box",
            link: "/master-ahsp",
            color: "cyan",
            action: {
              add: false,
              update: false,
              delete: false,
              detail: false,
              ubah_detail: false,
              delete_detail: false
            }
          },
          {
            id: 7,
            label: "Project",
            icon: "mdi-folder-account",
            link: "/project",
            color: "#00838F",
            action: {
              detail: false,
              add: false,
              update: false,
              delete: false,
                penawaran: false,
                negosiasi: false,
                pelaksanaan: false,
                rab_internal: false,
                add_rab_internal: false,
                update_rab_internal: false,
                delete_rab_internal: false,
                detail_rab_internal: false,
                add_detail_rab_internal: false,
                update_detail_rab_internal: false,
                delete_detail_rab_internal: false,
                rab_penawaran: false,
                update_tools_rab_penawaran: false,
                update_rab_penawaran: false,
                delete_rab_penawaran: false,
                bobot: false,
                update_bobot: false,
                document: false,
                update_document: false,
                chacklist_persiapan: false,
                update_penawaran: false,
                update_negosiasi: false,
                update_pelaksanaan: false,
                rencana_kebutuhan: false,
                update_rencana_kebutuhan: false,
                rencana_belanja: false,
                realisasi_kebutuhan: false,
                add_realisasi_kebutuhan: false,
                update_realisasi_kebutuhan: false,
                realisasi_belanja: false,
                update_realisasi_belanja: false,
                kemajuan_pekerjaan: false,
                update_kemajuan_pekerjaan: false,
                cco: false,
                berita_acara: false,
                add_berita_acara: false,
                update_berita_acara: false,
                delete_berita_acara: false,
                tahap_pembayaran: false,
                add_tahap_pembayaran: false,
                update_tahap_pembayaran: false,
                delete_tahap_pembayaran: false,
                ketentuan_pembayaran: false,
                pengadaan: false,
                add_pengadaan: false,
                update_pengadaan: false,
                delete_pengadaan: false,
                item_pengadaan: false,
                update_item_pengadaan: false,
                pembayaran_pengadaan: false,
                update_pembayaran_pengadaan: false
            }
          },
          {
            id: 9,
            label: "Audit Trail",
            icon: "mdi-list-box",
            link: "/audit",
            color: "#455A64",
            action:{
              export: false,
            }
          },
          {
            id: 14,
            label: "Vendor",
            icon: "mdi-home-account",
            link: "/vendor",
            color: "#00838F",
            action: {
              add: true,
              update: true,
              delete: true,
              add_rencana: true,
              export: true,
              delete_rencana: true,
              // data_report_rencana: true,
              add_report_rencana: true,
              delete_report_rencana: true,
              add_project: true,
              delete_project: true
            }
          },
          {
            id: 11,
            label: "Pegawai",
            icon: "mdi-account-group",
            link: "/user",
            color: "primary",
            action: {
              add: true,
              update: true,
              delete: true,
              export: true,
              reset_password: true
            }
          },
          {
            id: 12,
            label: "Kategori Pegawai",
            icon: "mdi-shape",
            link: "/category-user",
            color: "#4A148C",
            action: {
              add: true,
              update: true,
              delete: true
            }
          },
          {
            id: 13,
            label: "Konfigurasi",
            icon: "mdi-cog-outline",
            link: "/config",
            color: "black",
            action:{}
          }
        ],

        form: {
          id: '',
          title: '',
          menu_arr: []
        },

        process: {
          load: false,

          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.id': function() {
        let t = this

        let r = this.role.filter(function(v) {
          return t.form.id == v
        })

        if (r.length > 0) {
          this.form.title = r[0].name
          
          this.fetchRole()
        }
      },
      'form.menu_arr': function(val) {
        val.filter(function(v) {
          return v === 1
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 1) {
            console.log(l)
            l.action = {
              add: false,
              update: false,
              delete: false,
              export: false,
              add_sub: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 2
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 2) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''

        val.filter(function(v) {
            return v === 7
          }).length < 1 ? this.list.map(function(l) {
            if (l.id === 7) {
              l.action = {
                add: false,
                update: false,
                delete: false,
                penawaran: false,
                negosiasi: false,
                pelaksanaan: false,
                rab_internal: false,
                add_rab_internal: false,
                update_rab_internal: false,
                delete_rab_internal: false,
                detail_rab_internal: false,
                add_detail_rab_internal: false,
                update_detail_rab_internal: false,
                delete_detail_rab_internal: false,
                rab_penawaran: false,
                update_tools_rab_penawaran: false,
                update_rab_penawaran: false,
                delete_rab_penawaran: false,
                bobot: false,
                update_bobot: false,
                document: false,
                update_document: false,
                chacklist_persiapan: false,
                update_penawaran: false,
                update_negosiasi: false,
                update_pelaksanaan: false,
                rencana_kebutuhan: false,
                update_rencana_kebutuhan: false,
                rencana_belanja: false,
                realisasi_kebutuhan: false,
                add_realisasi_kebutuhan: false,
                update_realisasi_kebutuhan: false,
                realisasi_belanja: false,
                update_realisasi_belanja: false,
                kemajuan_pekerjaan: false,
                update_kemajuan_pekerjaan: false,
                cco: false,
                berita_acara: false,
                add_berita_acara: false,
                update_berita_acara: false,
                delete_berita_acara: false,
                tahap_pembayaran: false,
                add_tahap_pembayaran: false,
                update_tahap_pembayaran: false,
                delete_tahap_pembayaran: false,
                ketentuan_pembayaran: false,
                pengadaan: false,
                add_pengadaan: false,
                update_pengadaan: false,
                delete_pengadaan: false,
                item_pengadaan: false,
                update_item_pengadaan: false,
                pembayaran_pengadaan: false,
                update_pembayaran_pengadaan: false
              }
            }
          }) : ''

        val.filter(function(v) {
          return v === 11
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 11) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              export: false,
              reset_password: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 12
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 12) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 14
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 14) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              add_rencana: false,
              delete_rencana: false,
              export: false,
              // data_report_rencana: false,
              add_report_rencana: false,
              delete_report_rencana: false,
              add_project: false,
              delete_project: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 15
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 15) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              detail: false,
              ubah_detail: false,
              delete_detail: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 9
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 9) {
            l.action = {
              export: false
            }
          }
        }) : ''
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      this.fetch()
    },
    mounted () {
      
    },
    methods: {

      update_rab_internal(item) {
          item.action.add_rab_internal = false,
          item.action.update_rab_internal = false,
          item.action.delete_rab_internal = false,
          item.action.detail_rab_internal = false,
          item.action.add_detail_rab_internal = false,
          item.action.update_detail_rab_internal = false,
          item.action.delete_detail_rab_internal = false
        },
        update_rab_penawaran(item) {
          item.action.update_tools_rab_penawaran = false,
          item.action.update_rab_penawaran = false,
          item.action.delete_rab_penawaran = false
        },

        update_bobot(item) {
          item.action.update_bobot = false
        },

        update_document(item) {
          item.action.update_document = false
        },

        update_penawaran(item) {
          item.action.update_penawaran = false
        },

        update_negosiasi(item) {
          item.action.update_negosiasi = false
        },

        update_pelaksanaan(item) {
          item.action.update_pelaksanaan = false
        },

        update_rencana_kebutuhan(item) {
          item.action.update_rencana_kebutuhan = false
        },

        update_realisasi_belanja(item) {
          item.action.update_realisasi_belanja = false
        },

        update_realisasi_kebutuhan(item) {
          item.action.add_realisasi_kebutuhan = false,
          item.action.update_realisasi_kebutuhan = false
        },

        update_kemajuan_pekerjaan(item) {
          item.action.update_kemajuan_pekerjaan = false
        },

        update_berita_acara(item) {
          item.action.add_berita_acara = false,
          item.action.update_berita_acara = false,
          item.action.delete_berita_acara = false
        },

        update_tahap_pembayaran(item) {
          item.action.add_tahap_pembayaran = false,
          item.action.update_tahap_pembayaran = false,
          item.action.delete_tahap_pembayaran = false
        },

        update_pengadaan(item) {
          item.action.add_pengadaan = false,
          item.action.update_pengadaan = false,
          item.action.delete_pengadaan = false,
          item.action.item_pengadaan = false,
          item.action.update_item_pengadaan = false,
          item.action.pembayaran_pengadaan = false,
          item.action.update_pembayaran_pengadaan = false
        },

        update_pembayaran_pengadaan(item) {
          item.action.update_pembayaran_pengadaan = false
        },

        update_item_pengadaan(item) {
          item.action.update_item_pengadaan = false
        },
      async fetch () {
          this.process.load = true
  
          let params = {
            id: this.$route.params.id
          }
  
          this.form.menu_arr = []
  
          await get('admin/category/detail', { params })
          .then(response => {
            let res = response.data
  
            this.process.laod = false
              
            if (res.status === 200) {
              this.form.id = res.results.data.id
              this.form.title = res.results.data.title
              let data = res.results.data.menu_array.length > 0 ? res.results.data.menu_array : []
              this.form.menu_arr = data.map(function(v) {
                return v.id
              })

              for(let l in this.list){
                for(let a in data){
                  if(this.list[l].id == data[a].id){
                    this.list[l].action = data[a].action
                  }
                }
              }
  
            }
          })
        },


      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          // console.log(this.array_final())
          // let form = {
          //   title: this.form.title,
          //   menu_arr: JSON.stringify(this.form.menu_arr)
          // }
          let menu = []
          for(let l in this.list){
            for(let a in this.form.menu_arr){
              if(this.list[l].id == this.form.menu_arr[a]){
                menu.push(this.list[l])
              }
            }
          } 

          // this.form.menu_arr = JSON.stringify(this.array_final())

          // this.form.menu_arr = JSON.stringify(this.list)

          // SAVE TO REST API
          await post('admin/category/update', {
            data: {
              id: this.$route.params.id,
              title: this.form.title,
              menu_array: menu
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message
              this.$router.push({ path: '/category-user' })

              // this.fetchRole()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>